import { Link } from '@tanstack/react-router'
import { Bars3Icon } from '@heroicons/react/24/outline'
import { useMe } from '@api/generated'
import { DachIcon } from '@icons/dach'
import { ThemeToggle } from './ThemeToggle'
import UserProfileMenu from './UserProfileMenu'

const links = [
  { to: '/', label: 'Parkplatz', admin: false },
  { to: '/plates', label: 'Meine Kennzeichen', admin: false },
  { to: '/admin', label: 'Administration', admin: true },
  { to: '/log', label: 'Protokoll', admin: true },
] as const

export default function Header() {
  const me = useMe()
  const isAdmin = me.data?.admin ?? false
  const visibleLinks = links.filter((l) => !l.admin || isAdmin)
  return (
    <header className="header h-16 bg-base-300 shadow-sm">
      <div className="navbar justify-between px-4 sm:px-8">
        <div className="flex flex-row items-center gap-4 sm:gap-8">
          <div className="dropdown sm:hidden">
            <div
              tabIndex={0}
              role="button"
              className="btn btn-ghost btn-circle"
              aria-label="Navigationsmenü öffnen"
            >
              <Bars3Icon className="h-6 w-6" />
            </div>
            <ul
              tabIndex={-1}
              className="menu dropdown-content bg-base-200 rounded-box z-10 mt-3 w-52 gap-1 p-2 shadow"
            >
              {visibleLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    activeProps={{ className: 'menu-active' }}
                    activeOptions={{ exact: l.to === '/' }}
                    onClick={() =>
                      (document.activeElement as HTMLElement)?.blur()
                    }
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <Link to="/" className="flex items-center gap-3">
            <DachIcon className="h-8 w-auto fill-primary" />
          </Link>
          <nav className="hidden sm:flex gap-1">
            {visibleLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="btn btn-ghost btn-sm"
                activeProps={{ className: 'btn-active' }}
                activeOptions={{ exact: l.to === '/' }}
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="flex flex-row items-center gap-4">
          <ThemeToggle />
          <UserProfileMenu />
        </div>
      </div>
    </header>
  )
}
